import makeUrl from "../utils/UrlMaker";
import { Api } from "../utils/Api";

function login(username, password) {
  var body = {
    username: username,
    password: password,
  };

  return fetch(makeUrl("authServiceUrl", "/user/signin"), {
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    body: JSON.stringify(body),
  })
    .then((response) => {
      let bodtText = response.text();
      return bodtText;
    })
    .then((responseBodyAsText) => {
      try {
        const bodyAsJson = JSON.parse(responseBodyAsText);
        return bodyAsJson;
      } catch (e) {
        Promise.reject({ body: responseBodyAsText, type: "unparsable" });
      }
    });
}

function refreshToken(refresh_token) {
  if (refresh_token === undefined) refresh_token = JSON.parse({});
  return fetch(makeUrl("authServiceUrl", "/auth/token"), {
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    body: JSON.stringify(refresh_token),
  })
    .then((response) => {
      let bodyText = response.text();
      return bodyText;
    })
    .then((responseBodyAsText) => {
      try {
        const bodyAsJson = JSON.parse(responseBodyAsText);
        return bodyAsJson;
      } catch (e) {
        Promise.reject({ body: responseBodyAsText, type: "unparsable" });
      }
    });
}

function getAllUserInfo(token) {
  return Api.get("authServiceUrl", `managment/user`, token);
}

function getUserInfo(token, id) {
  return Api.get("authServiceUrl", `managment/user/${id}`, token);
}

function updateUserInfo(token, payload) {
  return Api.post(
    "authServiceUrl",
    `managment/user/${payload.id}`,
    token,
    payload
  );
}

function createUserInfo(token, payload) {
  return Api.post("authServiceUrl", `managment/user`, token, payload);
}

function validateSecret(token) {
  return Api.get("authServiceUrl", `auth/secret/validation`, token);
}

export const authService = {
  login,
  refreshToken,
  getAllUserInfo,
  getUserInfo,
  updateUserInfo,
  createUserInfo,
  validateSecret,
};
